import React from 'react';
import { CurrentOperationsStatusView } from '@fingo/lib/features/operations-status';
import CessionStatusOverlay from '../../../../features/factoring/components/overlays/CessionStatusOverlay';
import {
  getCurrentSummaryCards,
  DETAIL_SUMMARY_TABLE_COLUMNS,
} from '../../../../features/factoring/constants/operations-status';
import buildBchSteps from '../../../../features/factoring/helpers/invoiceTrackingSteps';

const CurrentOperationsStatus = () => (
  <CurrentOperationsStatusView
    getCards={getCurrentSummaryCards}
    summaryTableColumns={DETAIL_SUMMARY_TABLE_COLUMNS}
    getTrackingSteps={buildBchSteps}
    useBorderedTitle
    OverlayComponent={CessionStatusOverlay}
  />
);

export default CurrentOperationsStatus;
